import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserRole } from '../models/users/subrise-user.model';
import { UserRolesService } from '../services/user-roles.service';
import { loginUrlTree } from '../utils/login-return-url.utils';

/**
 * Grants access only to the owner of a practice. A practitioner working in the practice does not
 * pass: the practice section administers the practice itself, so it is gated the same way the
 * side menu gates it (see the `Practice` node in `side-menu.component.ts`).
 */
export const practiceOwnerGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const userRolesService = inject(UserRolesService);

  // Read the current auth state rather than the cached snapshot: right after logout the
  // snapshot still holds the signed-out user's roles, which would wave them back through.
  return userRolesService.resolveCurrentRoles().pipe(
    map((roles) => roles.includes(UserRole.PracticeOwner) || loginUrlTree(router, state, roles))
  );
};
